import * as yup from 'yup';

export const schema = yup.object().shape({
  name: yup.string().required('Use Case name is required'),
  policyId: yup.string().required('Please select an opt-out policy'),
  route: yup.boolean(),
  sticky: yup.boolean(),
  retryAlternateVendor: yup.boolean(),
  redact: yup.boolean(),
  inboundUrl: yup.string().required('Inbound URL is required'),
  statusUrl: yup.string().required('Status URL is required'),
  routingStrategy: yup.string().required('Please select a routing strategy'),
  ttl: yup
    .number()
    .typeError('TTL must be a number')
    .required('TTL is required'),
  notes: yup.string().optional(),
  senders: yup.array().of(
    yup.object().shape({
      id: yup.string(),
      name: yup.string(),
      vendorAccountId: yup.string(),
      smsEnabled: yup.boolean(),
      mmsEnabled: yup.boolean(),
      whatsAppEnabled: yup.boolean(),
      notes: yup.string(),
      type: yup.string(),
      active: yup.boolean(),
      number: yup.string().required('Phone number is required'),
      percentage: yup
        .number()
        .typeError('Percentage must be a number')
        .min(0, 'Percentage must be at least 0')
        .max(1, 'Percentage must be at most 1')
        .required('Percentage is required'),
      rate: yup
        .number()
        .typeError('Rate must be a number')
        .required('Rate is required'),
      defaultNumber: yup.boolean().test(
        'only-one-default',
        'Only one sender can be default',
        function (value) {
          if (!value) return true;
          const senders = this.from?.[1]?.value?.senders || [];
          return senders.filter(s => s.defaultNumber).length <= 1;
        }
      ),
    })
  )
  .min(1, 'At least one sender is required')
  .test(
    'exactly-one-default',
    'Exactly one sender must be set as the default',
    (senders = []) => {
      if (!senders || senders.length === 0) return true;
      return senders.filter(s => s.defaultNumber).length === 1;
    }
  )
  .test(
    'percentage-sum',
    'Total percentage of all senders must equal 1.0 (100%)',
    (senders = []) =>
      Number.isFinite(senders.reduce((sum, s) => sum + (Number(s.percentage) || 0), 0)) &&
      Math.abs(senders.reduce((sum, s) => sum + (Number(s.percentage) || 0), 0) - 1) < 1e-6
  ),
});

export const strategyOptions = [
  { value: 'SPLIT', label: 'Split' },
  { value: 'ROUND_ROBIN', label: 'Round Robin' },
  { value: 'ROUND_ROBIN_BY_NUMBER', label: 'Round Robin By Number' },
];

export const breadcrumbPages = [{ name: 'Use Cases', href: '/templates' }];
